import React from "react";

const Loader: React.FC = () => {
    return (
        <div className="cabi-loader-container">
            <div className="cabi-spinner" />
            <p className="cabi-loader-text">Loading PRISE Bulletin...</p>
        </div>
    );
};

export default Loader;
